import { render, staticRenderFns } from "./PermissionUpload.vue?vue&type=template&id=63d092c4&scoped=true"
import script from "./PermissionUpload.vue?vue&type=script&lang=js"
export * from "./PermissionUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d092c4",
  null
  
)

export default component.exports